import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "" }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12 } } }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "" }) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ chapter, overline, title, sub, dark = false, testId }) {
  return (
    <Reveal className="max-w-3xl">
      <div className="flex items-center gap-4 mb-5">
        {chapter && <span className={`font-display text-sm font-bold ${dark ? "text-nexorange" : "text-nexorange"}`}>{chapter}</span>}
        <span className={`h-px w-12 ${dark ? "bg-nexcyan/60" : "bg-nexblue/25"}`} />
        <span className={`text-xs font-semibold uppercase tracking-[0.3em] ${dark ? "text-nexcyan" : "text-nexcyan"}`}>
          {overline}
        </span>
      </div>
      <h2
        data-testid={testId}
        className={`font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight ${dark ? "text-white" : "text-nexblue"}`}
      >
        {title}
      </h2>
      {sub && (
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-white/65" : "text-nexink/70"}`}>{sub}</p>
      )}
    </Reveal>
  );
}
